var map = {
	"./MyPortfolioImage1.png": 2237,
	"./MyPortfolioImage2.png": 1030,
	"./address_image.svg": 8415,
	"./amrita_logo.png": 1985,
	"./coursera_logo.png": 8857,
	"./duke-logo.jpg": 7308,
	"./gcp_logo.png": 4375,
	"./ggsipu_logo.png": 1972,
	"./google_logo.png": 6038,
	"./hybreathe-logo.jpeg": 7132,
	"./hybreathe-logo.png": 1803,
	"./ibm-logo.png": 2213,
	"./ibm_logo.jpg": 6955,
	"./id-logix-logo.png": 2324,
	"./infosys-logo.png": 502,
	"./mail.gif": 5141,
	"./mail.png": 5046,
	"./maryland_logo.svg": 945,
	"./meta_logo.png": 8672,
	"./mui-logo.png": 3918,
	"./my-cartoonic-img.png": 1514,
	"./my-portfolio-img-2.png": 9397,
	"./ottonomy-logo.webp": 1718,
	"./portfolioProfileImage.png": 1453,
	"./profileImgCatoonic.png": 7619,
	"./profileImgUpdated.png": 2834,
	"./pu-logo.png": 6568,
	"./superior-logo.png": 5988,
	"./uog-logo.png": 62,
	"./waving-hand.png": 7683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;